export const DISPLAY_MODE = {
  list: 'list',
  edit: 'edit',
  create: 'create',
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MultiVenue/constants/index.js